var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 27,
    viewBox: "0 0 61 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.910042 16.37L0.900032 16.31C0.880032 16.17 0.780042 16.07 0.660042 16.07C0.530042 16.07 0.430051 16.17 0.420051 16.31L0.350044 16.87C0.110044 18.73 0.110023 20.61 0.360023 22.47L0.430031 22.98C0.450031 23.12 0.550051 23.22 0.670051 23.22C0.790051 23.22 0.890042 23.12 0.910042 22.98C1.25004 20.8 1.25004 18.57 0.910042 16.37Z",
    fill: "url(#paint0_linear_18_12)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16005 14.36L3.15004 14.24C3.13004 14.1 3.03004 14 2.90004 14C2.77004 14 2.67004 14.1 2.65004 14.24C2.65004 14.24 2.62006 14.54 2.57006 14.99C2.23006 18.11 2.23004 21.26 2.58004 24.37L2.65004 25C2.67004 25.14 2.77004 25.25 2.90004 25.25C3.03004 25.25 3.13004 25.15 3.15004 25.01C3.60004 21.47 3.60005 17.89 3.16005 14.36Z",
    fill: "url(#paint1_linear_18_12)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.18 13.21L12.99 9.67998C12.98 9.42998 12.77 9.22998 12.53 9.22998C12.29 9.22998 12.08 9.42998 12.07 9.67998L11.9 13.21C11.7 17.53 11.75 21.85 12.07 26.16C12.08 26.41 12.28 26.61 12.53 26.61C12.77 26.61 12.97 26.41 12.99 26.16C13.35 21.85 13.41 17.52 13.18 13.21Z",
    fill: "url(#paint2_linear_18_12)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04999 13.27L8.03 13.05C8.01 12.85 7.86001 12.7 7.67001 12.7C7.48001 12.7 7.33 12.85 7.31 13.05L7.23001 14.03C6.93001 17.79 6.93 21.57 7.25 25.33L7.31 26.1C7.32 26.3 7.48001 26.45 7.67001 26.45C7.86001 26.45 8.01 26.3 8.03 26.1C8.44 21.83 8.43999 17.54 8.04999 13.27Z",
    fill: "url(#paint3_linear_18_12)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.27 13.32L18.03 6.37C18.02 6.06 17.77 5.81 17.47 5.81C17.16 5.81 16.92 6.05 16.91 6.37C16.91 6.37 16.78 10.41 16.67 14.04C16.55 17.81 16.62 21.59 16.86 25.35L16.91 26.06C16.92 26.37 17.17 26.61 17.47 26.61C17.77 26.61 18.02 26.37 18.03 26.05C18.34 21.81 18.42 17.56 18.27 13.32Z",
    fill: "url(#paint4_linear_18_12)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.54 13.51L28.35 4.3C28.34 3.88 28 3.53 27.58 3.53C27.16 3.53 26.82 3.87 26.81 4.3L26.62 14.17C26.55 17.85 26.6 21.53 26.77 25.2L26.8 25.87C26.81 26.29 27.15 26.63 27.57 26.63C27.99 26.63 28.33 26.29 28.34 25.86C28.56 21.76 28.62 17.63 28.54 13.51Z",
    fill: "url(#paint5_linear_18_12)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.36 13.42L23.1501 6.26999C23.1401 5.89999 22.8501 5.60999 22.4801 5.60999C22.1101 5.60999 21.8201 5.89999 21.8101 6.26999L21.61 14.11C21.51 17.83 21.5701 21.55 21.7801 25.27L21.8201 25.96C21.8301 26.33 22.1201 26.62 22.4901 26.62C22.8501 26.62 23.1501 26.33 23.1601 25.96V25.97C23.4101 21.78 23.48 17.6 23.36 13.42Z",
    fill: "url(#paint6_linear_18_12)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13.53C10.48 13.3 10.31 13.13 10.09 13.13C9.87004 13.13 9.70004 13.3 9.68004 13.53C9.34004 17.62 9.34005 21.74 9.66005 25.84L9.68004 26.15C9.69004 26.38 9.87004 26.55 10.09 26.55C10.31 26.55 10.48 26.38 10.5 26.15L10.53 25.84C10.89 21.75 10.88 17.62 10.5 13.53Z",
    fill: "url(#paint7_linear_18_12)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60002 13.46L5.58 13.23C5.56 13.06 5.43001 12.93 5.28001 12.93C5.12001 12.93 4.99003 13.05 4.98003 13.23C4.98003 13.23 4.95001 13.62 4.90001 14.2C4.58001 17.85 4.59003 21.52 4.92003 25.17L4.99 25.9C5.01 26.07 5.13002 26.2 5.29002 26.2C5.45002 26.2 5.58001 26.08 5.59001 25.9C6.01001 21.77 6.02002 17.6 5.60002 13.46Z",
    fill: "url(#paint8_linear_18_12)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9201 13.46L25.7301 6.75999C25.7201 6.35999 25.4101 6.04999 25.0101 6.04999C24.6201 6.04999 24.3001 6.35999 24.2901 6.75999L24.11 14.13C24.02 17.83 24.0701 21.54 24.2601 25.24L24.2901 25.91C24.3001 26.31 24.6101 26.62 25.0101 26.62C25.4001 26.62 25.7201 26.31 25.7301 25.91V25.92C25.9801 21.77 26.0401 17.62 25.9201 13.46Z",
    fill: "url(#paint9_linear_18_12)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7401 13.25L15.5001 7.39001C15.4901 7.11001 15.2601 6.88 14.9901 6.88C14.7201 6.88 14.4901 7.10001 14.4801 7.39001C14.4801 7.39001 14.3801 10.27 14.2701 13.25C14.1201 17.54 14.1901 21.84 14.4801 26.12C14.4901 26.4 14.7201 26.62 14.9901 26.62C15.2601 26.62 15.4901 26.4 15.5001 26.11C15.8401 21.83 15.9101 17.54 15.7401 13.25Z",
    fill: "url(#paint10_linear_18_12)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.81 13.36L20.58 5.90999C20.57 5.56999 20.3 5.29999 19.97 5.29999C19.64 5.29999 19.37 5.56999 19.36 5.90999L19.13 14.06C19.03 17.81 19.09 21.56 19.31 25.3L19.35 26.01C19.36 26.35 19.63 26.62 19.96 26.62C20.29 26.62 20.56 26.35 20.57 26.01C20.87 21.8 20.94 17.58 20.81 13.36Z",
    fill: "url(#paint11_linear_18_12)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M53.53 11.76C52.35 11.69 51.23 11.9 50.22 12.33C49.63 5.61 44 0.339996 37.13 0.339996C35.45 0.339996 33.81 0.669996 32.36 1.23C31.8 1.45 31.65 1.67 31.64 2.11V25.76C31.65 26.22 32 26.6 32.44 26.64C32.46 26.64 52.96 26.65 53.1 26.65C57.24 26.65 60.59 23.28 60.55 19.13C60.52 15.28 57.38 11.98 53.53 11.76Z",
    fill: "url(#paint12_linear_18_12)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.17 13.59L30.94 2.89999C30.93 2.44999 30.57 2.07999 30.12 2.07999C29.67 2.07999 29.3 2.44999 29.3 2.89999L29.08 14.07C29.01 17.81 29.07 21.55 29.28 25.29L29.31 25.78C29.32 26.22 29.68 26.59 30.13 26.59C30.58 26.59 30.94 26.22 30.95 25.77V25.78C31.18 21.73 31.26 17.66 31.17 13.59Z",
    fill: "url(#paint13_linear_18_12)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_12",
    x1: -166.529,
    y1: 186.837,
    x2: 34.8012,
    y2: -14.4949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FEC978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFB3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#55E1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18_12",
    x1: -165.426,
    y1: 187.945,
    x2: 35.9078,
    y2: -13.3895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FEC978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFB3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#55E1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_18_12",
    x1: -161.46,
    y1: 191.909,
    x2: 39.8735,
    y2: -9.42344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FEC978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFB3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#55E1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_18_12",
    x1: -163.059,
    y1: 190.312,
    x2: 38.2761,
    y2: -11.0213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FEC978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFB3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#55E1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_18_12",
    x1: -159.845,
    y1: 193.522,
    x2: 41.4878,
    y2: -7.80906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FEC978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFB3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#55E1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_18_12",
    x1: -155.356,
    y1: 198.016,
    x2: 45.9781,
    y2: -3.31907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FEC978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFB3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#55E1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_18_12",
    x1: -157.389,
    y1: 195.98,
    x2: 43.9443,
    y2: -5.35263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FEC978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFB3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#55E1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_18_12",
    x1: -161.715,
    y1: 191.652,
    x2: 39.6167,
    y2: -9.67984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FEC978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFB3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#55E1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_18_12",
    x1: -164.264,
    y1: 189.106,
    x2: 37.0697,
    y2: -12.2275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FEC978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFB3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#55E1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_18_12",
    x1: -156.01,
    y1: 197.362,
    x2: 45.3235,
    y2: -3.97389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FEC978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFB3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#55E1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_18_12",
    x1: -160.813,
    y1: 192.557,
    x2: 40.5207,
    y2: -8.77653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FEC978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFB3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#55E1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_18_12",
    x1: -158.722,
    y1: 194.65,
    x2: 42.6131,
    y2: -6.68424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FEC978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFB3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#55E1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_18_12",
    x1: -147.417,
    y1: 205.527,
    x2: 53.6779,
    y2: 4.43278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FEC978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFB3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#55E1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_18_12",
    x1: -154.455,
    y1: 198.916,
    x2: 46.8782,
    y2: -2.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FEC978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFB3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#55E1FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.72a14a70dbd9717b69d870179792aba0.svg";
export { ForwardRef as ReactComponent };